import React from "react";

import t from "../../../../Common/utils/translation/translator";

import AxisSelectionFilterProductInfoSection from "./AxisSelectionFilterProductInfoSection";

import Pad4xTwoToothedBelt from "../../../../Cartesian/Assets/profileType/PAD4xTwoToothedbeltAxis.svg";
import Pas4xBallScrewAxis from "../../../../Cartesian/Assets/profileType/PAS4xBallscrewAxis.svg";
import Pas4xToothedBeltAxis from "../../../../Cartesian/Assets/profileType/PAS4xToothedbeltAxis.svg";
import Tas4xBallScrewLinearTable from "../../../../Cartesian/Assets/profileType/TAS4xBallscrewLinearTable.svg";

const AxisSelectionFilterProductTypeSection = ({
  cartesianPossibleFiltersValues,
  cartesianFilters,
  onProductTypeChange,
  dependencies
}) => {
  const productTypeImagesMapping = {
    "PAD4 axis with two toothed belt": Pad4xTwoToothedBelt,
    "PAS4 axis with toothed belt": Pas4xToothedBeltAxis,
    "PAS4 axis with ball screw": Pas4xBallScrewAxis,
    "TAS4 axis with ball screw linear table": Tas4xBallScrewLinearTable
  };

  const axisTypes = cartesianPossibleFiltersValues?.axis?.axisType || [];
  // exclude the 4 first elements for the first version
  const filtredAxisTypes = axisTypes.filter(
    (axisType) =>
      ![
        "CAR axis with toothed belt",
        "CAS axis with toothed belt",
        "MAXH double axis with toothed belt",
        "MAXS double axis with toothed belt"
      ].includes(axisType)
  );

  const midPoint = Math.ceil(filtredAxisTypes.length / 2);
  const firstHalf = filtredAxisTypes.slice(0, filtredAxisTypes.length);
  const secondHalf = filtredAxisTypes.slice(0, 0);

  return (
    <div className="flex flex-col flex-1 space-y-4">
      <span className="font-semibold text-gray-700 mb-2">{t("cartesian.ui.axis_selection.product_ranges")}</span>
      <div className="flex flex-col space-y-5" key={cartesianFilters?.axisFilters?.axisType}>
        {[firstHalf, secondHalf].map((half) => (
          <div className="flex items-center justify-center space-x-7">
            {half.map((axisType) => {
              return (
                <AxisSelectionFilterProductInfoSection
                  image={productTypeImagesMapping[axisType]}
                  title1={axisType?.split(" ")[0]}
                  title2={axisType?.split(" ").slice(1).join(" ")}
                  value={axisType}
                  isSelected={cartesianFilters.axisFilter.axisType?.includes(axisType)}
                  handleCheckboxChange={() => {
                    // Create a copy of the current axisType array or initialize it if it's not defined
                    const currentAxisTypes = cartesianFilters.axisFilter.axisType || [];

                    // Check if the axisType is already included
                    const index = currentAxisTypes.indexOf(axisType);

                    // If it's included, create a new array excluding it; otherwise, add it to the array
                    const newAxisTypes =
                      index >= 0
                        ? [...currentAxisTypes.slice(0, index), ...currentAxisTypes.slice(index + 1)]
                        : [...currentAxisTypes, axisType];

                    // Now, newAxisTypes contains the toggled array of axis types
                    onProductTypeChange(newAxisTypes);
                  }}
                  disabled={!dependencies?.axisType?.includes(axisType)}
                />
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
};

export default AxisSelectionFilterProductTypeSection;
